import './Header.scss';
import './Header.sticky.scss';

const scrollOffset = 50;

export default class HeaderDesktop {

    init() {
        window.onscroll = () => {
            let header = document.getElementById('main-header');
            let stickyClass = 'sticky';

            if (window.pageYOffset > scrollOffset) {
                if (!header.classList.contains(stickyClass)) {
                    header.classList.add(stickyClass);
                }
            }
            else {
                header.classList.remove(stickyClass);
            }
        };
    }
}


// WEBPACK FOOTER //
// ./Src/Shared/Header/HeaderDesktop.js